<script>
  import API from "@/utils/input-output/api";
  import formatDate from "@/utils/date/format";
  import constants from "./constants"

  export default {
    components: {
      BackOfficeDailyTips: () => import("./backoffice/Index.vue"),
      PartnerDailyTips: () => import("./partner/Index.vue"),
    },
    data() {
      return {
        content: [],
        isLoading: false,
        showModal: false,
      };
    },
    computed: {
      user() {
        return this.$store.state.User.user
      },
      isBackoffice() {
        return this.$store.getters["Authorization/isBackoffice"];
      },
      isPartner() {
        return this.$store.getters["Authorization/isPartner"];
      },
    },

    watch: {
      user: {
        immediate: true,
        deep: true,
        handler(newVal) {
          if (Object.keys(newVal).length && this.isPartner) {
            this.fetchDailyTips()
          }
        },
      },
    },

    methods: {
      openModal() {
        if (!this.content.length) {
          this.fetchDailyTips()
        }
        this.showModal = true
      },

      closeModal() {
        this.$store.dispatch("Loader/cancelRequests", {
          requests: [{ id: "fetchDailyTips" }, { id: "uploadCreatives" }],
        })
        this.showModal = false
      },

      fetchDailyTips() {
        this.isLoading = true;

        const currentDate = this.$BOOSTINY_NEW_DATE()
        const options = {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        }
        const from = formatDate({
          date: this.$BOOSTINY_NEW_DATE([currentDate.getFullYear(), currentDate.getMonth(), 1]),
          locale: "fr-CA",
          options,
        })
        const to = formatDate({
          date: this.$BOOSTINY_NEW_DATE([currentDate.getFullYear(), currentDate.getMonth() + 1, 0]),
          locale: "fr-CA",
          options,
        })

        API({
          url: constants.dailyTips(),
          method: "GET",
          requestId: "fetchDailyTips",
          params: { from, to, limit: 50 },
        }).then(({ data }) => {
          this.isLoading = false
          this.content = data.payload.data

          this.checkLastVisitDate()
        }).catch(() => {
          this.isLoading = false
          this.closeModal()
        })
      },

      checkLastVisitDate() {
        API({
          url: constants.checkLastVisitDate(),
          method: "GET",
          requestId: "checkLastVisitDate",
        }).then(({ data }) => {
          const lastVisitedAt = data.payload.data.lastVisitedAt ? this.$BOOSTINY_NEW_DATE(data.payload.data.lastVisitedAt).setHours(0, 0, 0, 0) : null
          const today = this.$BOOSTINY_NEW_DATE().setHours(0, 0, 0, 0)
          const isHavingTipToday = this.content.some((tip) => {
            const tipDate = this.$BOOSTINY_NEW_DATE(tip.date);
            return tipDate && tipDate.toDateString() === this.$BOOSTINY_NEW_DATE().toDateString();
          })
          if (
            (!lastVisitedAt || lastVisitedAt < today)
            && this.content.length
            && isHavingTipToday) {
            if (this.isPartner) {
              this.openModal()
            }

            API({
              url: constants.checkLastVisitDate(),
              method: "POST",
              requestId: "updateVisitDate",
            })
          }
        })
      },
    },
  };
</script>
<template>
  <div v-if="isBackoffice || (isPartner && content.length)">
    <transition name="fadeUp">
      <BackOfficeDailyTips
        v-if="isBackoffice && showModal"
        :content="content"
        :is-loading="isLoading"
        @close="closeModal"
        @refetch-tips="fetchDailyTips"
      />
      <PartnerDailyTips
        v-if="isPartner && showModal"
        :content="content"
        @close="closeModal"
      />
    </transition>

    <!--  the activator for different view [ header & sidebar ]  -->
    <div @click="openModal">
      <slot />
    </div>
  </div>
</template>
<style>
</style>
